import { SidebarItem } from '@shared/sidebaritem';

export const sidebarItems: SidebarItem[] = [
	{
		label: 'Administration',
		icon: 'acies_organization',
		path: 'administration',
		overlay: false,
		permission: 'insights:UserReportCreate',
		parents: ['AciesInsights'],
		children: [
			{
				label: 'Brugeradgang',
				icon: 'acies_user',
				path: 'insights/administration/users',
				overlay: false,
				children: [],
				permission: 'insights:UserCreate',
				parents: ['AciesInsights', 'Administration'],
				forceTranslateKey: 'insights.sidebar.administration.brugeradgang',
			},
			{
				label: 'Kontoadgang',
				icon: 'acies_account',
				path: 'insights/administration/accounts',
				overlay: false,
				children: [],
				parents: ['AciesInsights', 'Administration'],
				permission: 'insights:AccountCreate',
				forceTranslateKey: 'insights.sidebar.administration.kontoadgang',
			},
			{
				label: 'Rapporter',
				icon: 'acies_admin_report',
				path: 'insights/administration/adminreports',
				overlay: false,
				children: [],
				parents: ['AciesInsights', 'Administration'],
				permission: 'insights:UserReportCreate',
				forceTranslateKey: 'insights.sidebar.administration.rapporter',
			},
			{
				label: 'Budget',
				icon: 'acies_policy',
				path: 'insights/administration/budgets',
				overlay: false,
				children: [],
				parents: ['AciesInsights', 'Administration'],
				permission: 'insights:BudgetCreate',
				forceTranslateKey: 'insights.sidebar.administration.budget',
			},
		],
	},
	{
		label: 'Vis rapport',
		icon: 'acies_analytics',
		path: 'insights/reports',
		overlay: false,
		children: [],
		parents: ['AciesInsights'],
		shortcut: 'control.alt.r',
		permission: 'insights:UserReportGet',
		forceTranslateKey: 'insights.sidebar.administration.vis_rapport',
	},
];
